import React from "react";

export default function Kodak() {
return( <div><svg
    xmlns="http://www.w3.org/2000/svg"
    width="51.742"
    height="45"
    viewBox="0 0 51.742 45"
    aria-label="Kodak Logo"
    // style={{ maxWidth: "1200px" }}
  >
    <g data-name="Artwork 1" transform="translate(-2554.919 -1052.389)">
      <g data-name="Group 305" transform="translate(2554.919 1052.389)">
        <path
          data-name="Path 5"
          d="M3060.158,1206.429a1.586,1.586,0,0,0,1.812-1.819c0-1.1-.551-1.662-1.812-1.662s-1.8.566-1.8,1.662A1.581,1.581,0,0,0,3060.158,1206.429Z"
          transform="translate(-3015.969 -1190.235)"
          fill="red"
        ></path>
        <path
          data-name="Path 6"
          d="M3063.713,1298.454h-1.769v3.316h1.769c.967,0,1.368-.662,1.368-1.748C3065.081,1298.959,3064.68,1298.454,3063.713,1298.454Z"
          transform="translate(-3019.248 -1277.675)"
          fill="red"
        ></path>
        <path
          data-name="Path 7"
          d="M2560.107,1076.717a3.119,3.119,0,0,1-.745-1.625,2.278,2.278,0,0,1,.372-1.3l14.528-19.7a.962.962,0,0,0,.167-.608,1.1,1.1,0,0,0-1.121-1.1h-15.068a3.365,3.365,0,0,0-3.32,3.33V1094.1a3.3,3.3,0,0,0,3.32,3.289h15.068a1.105,1.105,0,0,0,1.121-1.1,1.36,1.36,0,0,0-.208-.69Z"
          transform="translate(-2554.919 -1052.389)"
          fill="red"
        ></path>
        <path
          data-name="Path 8"
          d="M3067.605,1394.063h2l-1-2.489Z"
          transform="translate(-3024.421 -1362.919)"
          fill="red"
        ></path>
        <path
          data-name="Path 9"
          d="M2667.906,1052.389h-14.621a4.792,4.792,0,0,0-3.281,1.543l-24.337,20.713a.59.59,0,0,0,0,.812l24.985,21a4.242,4.242,0,0,0,2.633.935h14.58a3.27,3.27,0,0,0,3.28-3.289v-38.381A3.324,3.324,0,0,0,2667.906,1052.389Zm-7,3.756h1.387v2.513l2.495-2.513h1.931l-2.791,2.742,2.9,2.734h-1.981l-2.552-2.507v2.507h-1.387Zm2.873,7.806c2.037,0,3.171.941,3.171,2.8,0,1.824-1.1,2.947-3.171,2.947s-3.171-1.123-3.171-2.947C2660.61,1064.891,2661.745,1063.951,2663.782,1063.951Zm3,10.781c0,1.775-.791,2.837-2.742,2.837h-3.12v-5.529h3.12C2665.988,1072.04,2666.779,1072.956,2666.779,1074.731Zm-1.931,18.761-2.552-2.507v2.507h-1.387v-5.475h1.387v2.513l2.495-2.513h1.844l-2.7,2.742,2.9,2.734Zm.7-7.959-.388-.968h-2.772l-.38.968h-1.477l2.37-5.575h1.829l2.363,5.575Z"
          transform="translate(-2619.402 -1052.389)"
          fill="red"
        ></path>
      </g>
    </g>
  </svg></div>);
};
